import { PlusOutlined, SyncOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { overlays } from '@revenuemarket/overlays';
import { Button, Divider, Select } from 'antd';

import BusinessEntityCreateModal from '~components/BusinessEntity/BusinessEntityCreateModal';
import useBusinessEntityListQuery from '~hooks/queries/useBusinessEntityListQuery';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';

interface Props {
  value: number | null;
  onChange: (value: number | null) => void;
  style?: React.CSSProperties;
}

const BusinessEntityLabelSelect: React.FC<Props> = ({ value, onChange, style }) => {
  const { companyId } = useDemoAwareCompanyId();

  const { data: businessEntityData, refetch } = useBusinessEntityListQuery({
    companyId: companyId as string,
    favoriteOnly: false,
  });

  const businessEntityLabelOptions =
    businessEntityData?.Data?.data?.map((b) => ({
      label: `${b.name} / ${b.businessRegNumber}`,
      value: b.id,
    })) || [];

  return (
    <Select
      style={{ flex: 1, ...style }}
      options={businessEntityLabelOptions}
      value={value}
      onChange={(value) => {
        onChange(value);
      }}
      showSearch
      filterOption={(input, option) => {
        return (option?.label ?? '')?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      placeholder="거래처 분류 선택"
      dropdownRender={(menu) => {
        return (
          <Flex direction="column">
            {menu}
            <Divider
              style={{
                margin: '8px 0px',
              }}
            />
            <Flex align="center">
              <Button
                icon={<PlusOutlined />}
                onClick={() => {
                  overlays.open(({ isOpen, onClose }) => (
                    <BusinessEntityCreateModal
                      open={isOpen}
                      onCancel={onClose}
                      onCreate={() => {
                        refetch();
                      }}
                    />
                  ));
                }}
              >
                거래처 등록
              </Button>
              <Button
                type="link"
                icon={<SyncOutlined />}
                onClick={() => {
                  onChange(null);
                }}
              >
                거래처분류 초기화
              </Button>
            </Flex>
          </Flex>
        );
      }}
    />
  );
};

export default BusinessEntityLabelSelect;
